import Vue from 'vue'
import Vuex from 'vuex'


import loginStore from '../modules/login/loginStore.js';
import vendasStore from '../modules/vendas/vendasStore.js';
import imoveisStore from '../modules/imoveis/imoveisStore.js';
import clientesStore from '../modules/clientes/clientesStore.js';
import dashboardStore from '../modules/dashboard/dashboardStore.js';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false
  },
  
  // MUTATIONS
  mutations: {
    showLoading(state) {
      state.loading = true;
    },
    hideLoading(state) {
      state.loading = false;
    }
  },

  //ACTIONS
  actions: {
    showLoading(context) {
      context.commit('showLoading')
    },
    hideLoading(context) {
      context.commit('hideLoading')
    }
  },
  modules: {
    dashboardStore: {
      namespaced: true,
      ...dashboardStore
    },
    vendasStore: {
      namespaced: true,
      ...vendasStore
    },
    clientesStore: {
      namespaced: true,
      ...clientesStore
    },
    imoveisStore: {
      namespaced: true,
      ...imoveisStore
    },
    loginStore: {
      namespaced: true,
      ...loginStore
    }
  }
})
